const relative = new Intl.RelativeTimeFormat('fr-FR', { numeric: 'auto' })

const MINUTE = 60_000
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR

/**
 * « il y a 12 minutes », « hier »… — la datation du journal de synchro, telle que le prototype
 * validé la présente.
 *
 * Un écart, pas une date : sur le terrain, la question n'est jamais « quelle heure était-il »
 * mais « est-ce que ça vient de partir ». La date exacte reste accessible — l'écran la met en
 * `title` et en `datetime` sur l'élément `<time>`.
 *
 * ⚠️ `now` est un paramètre : l'heure de rendu n'est pas une constante de module, sans quoi un
 * journal ouvert en début de tournée afficherait encore « à l'instant » deux heures plus tard.
 */
export function relativeTime(iso: string, now: Date): string {
  const elapsed = now.getTime() - new Date(iso).getTime()

  // En dessous de la minute, un « il y a 0 minute » ne dit rien ; « à l'instant » se comprend.
  if (elapsed < MINUTE) return "à l'instant"
  if (elapsed < HOUR) return relative.format(-Math.floor(elapsed / MINUTE), 'minute')
  if (elapsed < DAY) return relative.format(-Math.floor(elapsed / HOUR), 'hour')

  return relative.format(-Math.floor(elapsed / DAY), 'day')
}
